import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily } from "../../Constants/baseStyles"
import Constants from "expo-constants"
import { basePadding } from "../../Constants/baseStyles"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: baseColors.white
    },
    icon: {
        flex: 0.2,
        marginLeft: 20
    },
    titleContainer: {
        flex: 0.8,
        marginTop: -5
    },
    title: {},
    subTitle: {
        marginTop: 5
    }
})

export default styles
